import { hasUnmetBookabilityCriteria } from "./hasUnmetBookabilityCriteria";
import { type BookabilityStatusItem, BookabilityUnmetCriteria } from "./types";

export function hasInstantBookCriteriaUnmet(bookabilityStatus?: BookabilityStatusItem | undefined) {
  return hasUnmetBookabilityCriteria(bookabilityStatus, [
    BookabilityUnmetCriteria.SHIFT_INSTANT_BOOK_DISABLED,
  ]);
}
